module.exports = __webpack_public_path__ + "static/img/sc17.34cd6ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc17.png
// module id = AxlA
// module chunks = 25